(() => {
  const init = (root) => {
    if (!root || root.dataset.nnReady === "true") return;
    root.dataset.nnReady = "true";

    const rail = root.querySelector("[data-nn-rail]");
    const previous = root.querySelector("[data-nn-rail-prev]");
    const next = root.querySelector("[data-nn-rail-next]");
    if (!rail || !previous || !next) return;

    const update = () => {
      const max = Math.max(0, rail.scrollWidth - rail.clientWidth);
      previous.disabled = rail.scrollLeft < 8;
      next.disabled = rail.scrollLeft > max - 8;
    };

    const move = (direction) => {
      const card = rail.querySelector(".nn-category-card");
      const distance = card ? card.getBoundingClientRect().width + 16 : rail.clientWidth * 0.8;
      rail.scrollBy({ left: distance * direction, behavior: "smooth" });
    };

    previous.addEventListener("click", () => move(-1));
    next.addEventListener("click", () => move(1));
    rail.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update, { passive: true });
    update();
  };

  const initAll = () => {
    document.querySelectorAll("[data-nn-collection]").forEach(init);
    document.querySelectorAll(".nn-bra-faq__item").forEach((item) => {
      if (item.dataset.nnFaqReady === "true") return;
      item.dataset.nnFaqReady = "true";
      const question = item.querySelector("h3");
      const answer = item.querySelector("p");
      if (!question || !answer) return;
      const button = document.createElement("button");
      button.type = "button";
      button.className = "nn-bra-faq__toggle";
      button.setAttribute("aria-expanded", "false");
      button.innerHTML = `${question.textContent}<b>＋</b>`;
      question.replaceWith(button);
      answer.hidden = true;
      button.addEventListener("click", () => {
        const open = button.getAttribute("aria-expanded") === "true";
        button.setAttribute("aria-expanded", String(!open));
        button.querySelector("b").textContent = open ? "＋" : "−";
        answer.hidden = open;
      });
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", initAll);
})();
